import { useState, useEffect } from 'react';
import { Typography, Button, Paper, Box, useTheme, useMediaQuery, Grid2, CardMedia, IconButton} from '@mui/material';
import Grid from '@mui/material/Grid2';
import Swal from 'sweetalert2';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import MyNumberInput from '../../components/inputs/MyNumberInput';
import MyTextInput from '../../components/inputs/MyTextInput';
import MyDateTimePicker from '../../components/inputs/MyDateTimePicker';
import MyDurationInput from '../../components/inputs/MyDurationInput';
import MySelectInput from '../../components/inputs/MySelectInput';
import MyAutoComplete from '../../components/inputs/MyAutoCompleteJavier';
import MyRadioGroup from '../../components/inputs/MyRadioGroup';
import axios from 'axios';
import { useFormikContext } from 'formik';
import Cookies from 'js-cookie';
import DeleteIcon from "@mui/icons-material/Delete";
import { useAuth } from '../../context/AuthProvider';
import LogoutIcon from '@mui/icons-material/Logout';

const myApiDiesel = axios.create({
    baseURL: 'https://apidiesel.ebtapps.com/api'
});

myApiDiesel.interceptors.request.use(
    (config) => {

        const token = Cookies.get('ebt_token');

        if (token) {
            config.headers['access-token'] = token;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

const Fuel_Up_Manual = () => {

    const { logOut } = useAuth();

    const [resetCounter, setResetCounter] = useState(0);

    const initialValues = 
    {
        date: null,

        asset: null,

        asset_type:  '',
        transportline:  '',
        Asset_trsnport_line:  '',

        order: '',

        driver:  null,

        //liters:  '',
        gallons: '',

        fuel_dispatcher: Cookies.get('ebt_nombre'),
        move_type:  '',

        tank_odometer:  '',

        brand: ''
        
    };

    const positiveNumber = (label, gender = 'El') => 
    {
        let verbo = 'es';
        let obligatorio = 'obligatorio';

        switch (gender) {
            case 'El':
                verbo = 'es';
                obligatorio = 'obligatorio';
                break;
            case 'La':
                verbo = 'es';
                obligatorio = 'obligatoria';
                break;
            case 'Los':
                verbo = 'son';
                obligatorio = 'obligatorios';
                break;
            case 'Las':
                verbo = 'son';
                obligatorio = 'obligatorias';
                break;
            default:
                verbo = 'es';
                obligatorio = 'obligatorio';
        }

        return Yup.string()
            .required(`${gender} ${label} ${verbo} ${obligatorio}`)
            .test('is-number', 'Debe ser un número válido', value => {
                if (!value) return false;
                const num = Number(value.toString().replace(/[^0-9.-]/g, ''));
                return !isNaN(num);
            })
            .test('positive', 'Debe ser mayor que 0', value => {
                const num = Number(value.toString().replace(/[^0-9.-]/g, ''));
                return num > 0;
            });
    };
    
    const validationSchema = Yup.object(
    {
        date: Yup.string().required('La fecha es obligatoria'),
        asset: Yup.string().required('La unidad es obligatoria'),
        driver: Yup.string().required('El operador es obligatorio'),
        move_type: Yup.string().required('Escoja si es IMPO o EXPO'),
        //liters: positiveNumber('cantidad LTS', 'La'),
        gallons: positiveNumber('cantidad GLLS', 'La'),
        tank_odometer: positiveNumber('odómetro del tanque', 'El'),
    });

    const [isSaving, setIsSaving] = useState(false);

    const norm = (x) =>
    String(x ?? '')
        .trim()
        .toUpperCase()
        .replace(/\s+/g, '')
        .replace(/[-_]/g, '');

    const resolveAssetType = async (values) => 
    {
        if (values.asset_type === 'CAJA') 
        {
            return 'CAJA';
        }

        if (values.asset_type === 'TRACTOR') 
        {
/*             const tractorInfo = tractorCatalog.find(
                t => t.value === values.asset
            ); */
            const tractorInfo = tractorCatalog.find(t => norm(t.value) === norm(values.asset));

            /* if (!tractorInfo) 
                return 'TRACTOR'; */

            if (!tractorInfo) 
            {
                Swal.fire({
                    icon: 'warning',
                    title: 'Catálogo incompleto',
                    text: 'No encontré la unidad en el catálogo. Espera a que termine de cargar y vuelve a intentar.',
                });
                throw new Error('No tractorInfo yet');
            }

            if (tractorInfo.company === 'TEDEL') 
            {
                return 'BPMX';
            }

            if (tractorInfo.company === 'EBT') 
            {
                try 
                {
                    const statuses = ['A', 'I', 'S'];

                    const requests = statuses.map(status =>
                    axios.post(
                        'https://apigeneral.ebtapps.com/general/api/mcleod/trucks/',
                        {
                        company: 'EBT',
                        status,
                        tractor: String(values.asset).trim(),
                        },
                        { timeout: 15000 }
                    )
                    );

                    const responses = await Promise.allSettled(requests);

                    const data = responses
                        .filter(r => r.status === 'fulfilled')
                        .flatMap(r => r.value.data || []);

                    const unique = Array.from(
                        new Map(data.map(item => [item.tractor, item])).values()
                    );

                    const typeOf = unique?.[0]?.type_of;
                    if (!typeOf) 
                    {
                        Swal.fire({ 
                            icon: 'warning', 
                            title: 'Sin tipo', 
                            text: 'McLeod no devolvió type_of para esa unidad.' 
                        });
                        throw new Error('No type_of');
                    }
                    return typeOf;
                }
                catch (e) 
                {
                    Swal.fire({ 
                        icon:'warning', 
                        title:'No se pudo resolver el tipo', 
                        text:'Intenta de nuevo.' });
                    throw e;
                }
            }
        }

        //return values.asset_type;
    };

    const handleSubmit = async (values, { resetForm }) => 
    {
        //const resolvedAssetType = await resolveAssetType(values);

        let resolvedAssetType;
        try 
        {
            resolvedAssetType = await resolveAssetType(values);
        } 
        catch 
        {
            return;
        }

        const catalog =
            values.asset_type === 'TRACTOR'
                ? tractorCatalog
                : values.asset_type === 'CAJA'
                ? cajaCatalog
                : [];

        //const assetInfo = catalog.find(a => a.value === values.asset);
        const assetInfo = catalog.find(a => norm(a.value) === norm(values.asset));
        const company = assetInfo?.company || 'EXTERNO';

        const marca = assetInfo?.marca || '';

        const formData = new FormData();
        formData.append('date', values.date);
        formData.append('asset', values.asset);
        formData.append('asset_type', resolvedAssetType);
        formData.append('transportline', company);
        formData.append('Asset_trsnport_line', company);
        formData.append('driver', values.driver);
        //formData.append('liters', values.liters);
        formData.append('gallons', values.gallons);
        formData.append('fuel_dispatcher', values.fuel_dispatcher);
        formData.append('move_type', values.move_type);
        formData.append('tank_odometer', values.tank_odometer);
        formData.append('brand', marca);
        formData.append('order', values.order);

        setIsSaving(true);
        try 
        {
            let responseCrear = await myApiDiesel.post('/cargasFuel/crearColombia', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if(responseCrear.data.success)
            {
                Swal.fire({
                    icon: 'success',
                    title: 'Carga creada',
                });
                resetForm();
                setResetCounter(c => c + 1);
            }
            else
            {
                Swal.fire({
                    icon: 'error',
                    title: 'Error al crear carga',
                    text: responseCrear.data.data || 'Ocurrió un error desconocido',
                });

                console.error('Error de API:', responseCrear.data);
            }
        } 
        catch (error) 
        {
            console.error('Error saving fuel up:', error);
        }
        finally 
        {
            setIsSaving(false);
        }
    };

    const fields = 
    [
        { 
            name: 'date', 
            label: 'FECHA', 
            type: 'datetime', 
            colSpan: 1 
        },
        {
            name: 'asset_type',
            label: 'TIPO DE UNIDAD',
            type: 'select',
            colSpan: 1,
            options: 
            [
                { 
                    value: 'TRACTOR', 
                    label: 'TRACTOR' },
                { 
                    value: 'CAJA', 
                    label: 'CAJA' 
                },
            ],
        },
        {
            name: 'asset',
            label: 'UNIDAD',
            type: 'autocomplete',
            colSpan: 1,
        },
        //{ name: 'asset', label: 'UNIDAD', type: 'text', colSpan: 1 },
        //{ name: 'truck_odometer', label: 'TRUCK ODOMETER', type: 'number', colSpan: 1 },
        //{ name: 'trailer_engine_hrs', label: 'TRÁILER ENGINE HOURS', type: 'number', colSpan: 1 },

        //{ name: 'asset_type', label: 'TIPO DE UNIDAD', type: 'text', colSpan: 1 },
        //{ name: 'transportline', label: 'TRANSPORTISTA', type: 'text', colSpan: 3 },
        /* { 
            name: 'transportline', 
            label: 'TRANSPORTISTA', 
            type: 'select', 
            colSpan: 3, 
            options: [
                { value: 'EBT', label: 'EBT' },
                { value: 'TEDEL', label: 'TEDEL' },
                { value: 'EXTERNO', label: 'EXTERNO' },
            ],
        }, */

        //{ name: 'Asset_trsnport_line', label: 'LINEA', type: 'text', colSpan: 3 },
        /* { 
            name: 'Asset_trsnport_line', 
            label: 'LINEA', 
            type: 'select', 
            colSpan: 3, 
            options: [
                { value: 'EBT', label: 'EBT' },
                { value: 'TEDEL', label: 'TEDEL' },
            ],
        }, */

        //{ name: 'driver', label: 'OPERADOR', type: 'text', colSpan: 3 },
        {
            name: 'driver',
            label: 'OPERADOR',
            type: 'autocomplete',
            colSpan: 3,
        },
        //{ name: 'location', label: 'UBICACION DE RELLENO', type: 'text', colSpan: 1 },
        /* {
            name: 'location',
            label: 'UBICACION DE RELLENO',
            type: 'select',
            colSpan: 3,
            options: [
                { value: 'COLOMBIA', label: 'COLOMBIA' },
                { value: 'LAREDO', label: 'LAREDO' },
            ],
        }, */


        { name: 'gallons', label: 'CANTIDAD GLLS', type: 'number', colSpan: 2 },
        //{ name: 'liters', label: 'CANTIDAD LTS', type: 'number', colSpan: 2 },
        //{ name: 'price', label: 'PRECIO', type: 'number', colSpan: 1 },
        //{ name: 'total', label: 'MONTO', type: 'number', colSpan: 1 },

        { name: 'order', label: 'ORDEN', type: 'text', colSpan: 1 },
        //{ name: 'fuel_dispatcher', label: 'DESPACHADOR', type: 'text', colSpan: 2 },
        //{ name: 'move_type', label: 'IMPO/EXPO', type: 'text', colSpan: 1 },
        {
            name: 'move_type',
            label: 'IMPO / EXPO',
            type: 'radio',
            colSpan: 1,
            options: [
                { value: 'Importación', label: 'IMPO' },
                { value: 'Exportación', label: 'EXPO' },
            ],
        },

        { name: 'tank_odometer', label: 'ODOMETRO TANQUE', type: 'number', colSpan: 1 },
        //{ name: 'qty_by_odometer', label: 'ODOMETRO TANQUE CONTRA GLLS', type: 'number', colSpan: 2 },
    ];

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

/*     const cajaCatalog = [
    { value: 'C-101', label: 'CAJA 101' },
    { value: 'C-102', label: 'CAJA 102' },
    ]; */

/*     const tractorCatalog = [
    { value: 'T-001', label: 'TRACTOR 001' },
    { value: 'T-002', label: 'TRACTOR 002' },
    ]; */

    const [tractorCatalog, setTractorCatalog] = useState([]);

    const companies = ['EBT', 'TEDEL'];
    const statuses = ['A', 'I', 'S'];

    useEffect(() => 
    {
        const fetchAllTractors = async () => 
        {
            try 
            {
                const requests = [];

                companies.forEach((company) => {
                    statuses.forEach((status) => {
                    requests.push(
                        axios.post(
                        'https://apigeneral.ebtapps.com/general/api/mcleod/trucks/',
                        {
                            company,
                            status,
                            tractor: null
                        },
                        { timeout: 15000 }
                        )
                    );
                    });
                });

                /* const responses = await Promise.all(requests);

                const allData = responses.flatMap((res) => res.data);

                const unique = Array.from(
                    new Map(allData.map((item) => [item.tractor, item])).values()
                ); */

                const responses = await Promise.allSettled(requests);
                const ok = responses.filter(r => r.status === 'fulfilled').map(r => r.value);
                const allData = ok.flatMap(res => res.data);

                const key = (x) => String(x ?? '').trim();
                const unique = Array.from(
                    new Map(
                    allData
                        .filter(item => item?.tractor != null)
                        .map(item => [key(item.tractor), item])
                    ).values()
                );

                const catalog = unique.map((item) => ({
                    value: item.tractor,
                    label: item.tractor,
                    company: item.company,
                    marca: item.make
                }));

                setTractorCatalog(catalog);
            } 
            catch (error) 
            {
                console.error('Error cargando tractores:', error);
            }
        };

        fetchAllTractors();
    }, []);

    const [cajaCatalog, setCajaCatalog] = useState([]);

    useEffect(() => 
    {
        const fetchAllTrailers = async () => 
        {
            try 
            {
                const requests = [];

                companies.forEach((company) => {
                    statuses.forEach((status) => {
                        requests.push(
                            axios.post(
                                'https://apigeneral.ebtapps.com/general/api/mcleod/trailers',
                                {
                                    company,
                                    status,
                                    trailer: null
                                }
                            )
                        );
                    });
                });

                const responses = await Promise.all(requests);

                const allData = responses.flatMap((res) => res.data);

                const uniqueTrailers = Array.from(
                    new Map(allData.map((item) => [item.trailer, item])).values()
                );

                const catalog = uniqueTrailers.map((item) => ({
                    value: item.trailer,
                    label: item.trailer,
                    company: item.company,
                    marca: item.make
                }));

                setCajaCatalog(catalog);
            } 
            catch (error) 
            {
                console.error('Error cargando trailers:', error);
            }
        };

        fetchAllTrailers();
    }, []);

    const AssetTypeWatcher = () => {
        const { values, setFieldValue } = useFormikContext();

        useEffect(() => {
            setFieldValue('asset', '');
            //setFieldValue('truck_odometer', '');
            //setFieldValue('trailer_engine_hrs', '');
        }, [values.asset_type, setFieldValue]);

        return null;
    };

    const [operadores, setOperadores] = useState([]);

    const findOperadores = async () => {
        try {
            const response = await myApiDiesel.get('/fuel_report/getOperadores');

            //console.log(response.data.data)

            let operadores = [];
            if (response.data.data && response.data.data.length > 0) {
                response.data.data.forEach(operador => {
                    operadores.push({ value: operador.nombre_completo, label: operador.nombre_completo });
                });
            }
            setOperadores(operadores.length > 0 ? operadores : []); 

        } catch (error) {
            console.error('Error fetching drivers:', error);
            setOperadores([]);
        }
    };

    useEffect(() => {
        findOperadores();
        //console.log(operadores)
        //console.log(Cookies.get('ebt_nombre'))
    }, []);

    const catalogsReady =
        tractorCatalog.length > 0 &&
        cajaCatalog.length > 0;

    return (
        <Paper sx={{ padding: 2 }}>
            <Grid container spacing={2}>
                <Grid item size={{ xs: 12, md: 8 }}>
                    <Typography variant="h4" fontWeight="bold" marginBottom={2}>
                        Agregar Carga de Colombia
                    </Typography>
                </Grid>

                <Grid
                    item
                    size={{ xs: 12, md: 4 }}
                    sx={{
                        display: 'flex',
                        justifyContent: { xs: 'flex-start', md: 'flex-end' },
                        alignItems: 'flex-start'
                    }}
                >
                    <Button
                        type="button"
                        variant="outlined"
                        color="error"
                        startIcon={<LogoutIcon />}
                        onClick={logOut}
                    >
                        Cerrar sesión
                    </Button>
                </Grid>
                <Grid item size={{ xs: 12 }}>
                    <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    >
                    {({ handleSubmit, touched, errors, values, setFieldValue }) => (
                        <>
                        <AssetTypeWatcher />
                        <Form onSubmit={handleSubmit}>
                        <Grid2 size={{xs: 12, sm: 12, md:12}} container spacing={2}>
                            {fields.map((field) => {

                            let InputComponent;
                            let extraProps = {};

                            if (field.type === 'text') InputComponent = MyTextInput;
                            else if (field.type === 'number') InputComponent = MyNumberInput;
                            else if (field.type === 'datetime') InputComponent = MyDateTimePicker;
                            else if (field.type === 'duration') InputComponent = MyDurationInput;
                            else if (field.type === 'select') InputComponent = MySelectInput;
                            else if (field.type === 'autocomplete') InputComponent = MyAutoComplete;
                            else if (field.type === 'radio') InputComponent = MyRadioGroup;

                            if (field.name === 'asset') 
                            {
                                extraProps.key = `asset-${values.asset_type}`;
                            }

                                if (field.type === 'autocomplete') {
                                extraProps.options =
                                values.asset_type === 'TRACTOR'
                                    ? tractorCatalog
                                    : values.asset_type === 'CAJA'
                                    ? cajaCatalog
                                    : [];
                            }

                            if (field.name === 'driver') 
                            {
                                extraProps.options = operadores;
                                extraProps.key = `driver-reset-${resetCounter}`;
                            }

                            const hasError =
                                touched[field.name] && Boolean(errors[field.name]);

                            return (
                                <Grid2 size={{xs: 12, sm: 12, md:12}}>
                                {/* <InputComponent
                                    fullWidth
                                    name={field.name}
                                    label={field.label}
                                    {...(field.type === 'datetime'
                                    ? {
                                        views: [
                                            'year',
                                            'month',
                                            'day',
                                            'hours',
                                            'minutes',
                                            'seconds',
                                        ],
                                        }
                                    : {})}
                                    {...(field.type === 'select' || field.type === 'autocomplete'
                                    ? { options: field.options }
                                    : {})}
                                    {...extraProps}
                                    error={hasError}
                                    helperText={hasError && errors[field.name]}
                                /> */}
                                {field.type === 'radio' ? (
                                    <InputComponent
                                        name={field.name}
                                        label={field.label}
                                        options={field.options || []}
                                    />
                                    ) : (
                                    <InputComponent
                                        key={extraProps.key} 
                                        fullWidth
                                        name={field.name}
                                        label={field.label}
                                        {...(field.type === 'select' || field.type === 'autocomplete'
                                            ? { options: field.options }
                                            : {})}
                                        {...extraProps}
                                        error={hasError}
                                        helperText={hasError && errors[field.name]}
                                    />
                                )}


                                {/* SOLO PARA FECHAS */}
                                {field.type === 'datetime' && hasError && (
                                    <div
                                    style={{
                                        color: '#D3302F',
                                        fontSize: '12px',
                                        marginTop: 4,
                                    }}
                                    >
                                    {errors[field.name]}
                                    </div>
                                )}
                                </Grid2>
                            );
                            })}
                            <Grid2 sx={{
                                xs: 12, sm: 12, md:12,
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: 1,
                                marginTop: 2,
                            }}>
                            <Button type="submit" variant="contained" disabled={!catalogsReady || isSaving} >
                                Guardar
                            </Button>
                            </Grid2>
                        </Grid2>
                        </Form>
                        </>
                    )}
                    </Formik>
                </Grid>
            </Grid>
        </Paper>
    );
}

export default Fuel_Up_Manual